import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './configImagemLoginForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';

import { 
	setModoTela, initForm, salvar, excluir, getLista
} from './configImagemLoginActions';
import { 
	getLista as getListaComentarioTipo
} from '../configImagemLogin/configImagemLoginActions';

class ConfigImagemLogin extends Component {

	state = {
		linhaSelecionada: null,
		ordenacao: {
			nome: 1
		}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista(this.props.nome);
		this.props.getListaComentarioTipo();
    }

    render() {
        return (
            <div style={{ height: '100%' }}>
                <Content height={'100%'}>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form tratativa onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form tratativa excluir onSubmit={(registro) => this.props.excluir(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


		let lista = this.props.lista.filter(item => {

			return !(this.state.pesquisar || '').trim()
				|| (this.state.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
				if (pesquisar
					&& !(`
					${item.nome}
					${(item.padrao ? 'Sim': 'Não')}
					${DateFormat.formatarDataSqlParaTela(item.data_inicio)}
					${DateFormat.formatarDataSqlParaTela(item.data_fim)}
				`).toUpperCase().includes(pesquisar)) {
					return false;
				}

				return true;

			}).length > 0;
			
		});

		if (this.state.ordenacao.nome) {
			lista.sort((a, b) => this.state.ordenacao.nome == 1 
				? (a.nome > b.nome ? 1 : -1) 
				: (a.nome > b.nome ? -1 : 1));
		} else if (this.state.ordenacao.padrao) {
			lista.sort((a, b) => this.state.ordenacao.padrao == 1 
				? ((a.padrao ? 'Sim': 'Não') > (b.padrao ? 'Sim': 'Não') ? 1 : -1) 
				: ((a.padrao ? 'Sim': 'Não') > (b.padrao ? 'Sim': 'Não') ? -1 : 1));
		} else if (this.state.ordenacao.data_inicio) {
			lista.sort((a, b) => this.state.ordenacao.data_inicio == 1 
				? (a.data_inicio > b.data_inicio ? 1 : -1) 
				: (a.data_inicio > b.data_inicio ? -1 : 1));
		} else if (this.state.ordenacao.data_fim) {
			lista.sort((a, b) => this.state.ordenacao.data_fim == 1 
				? (a.data_fim > b.data_fim ? 1 : -1) 
				: (a.data_fim > b.data_fim ? -1 : 1));
		}

		return (
			<ContentCard style={{ height: '100%' }}>
				<Row>
					<InputPesquisa
						maxWidth={350}
						minWidth={350}
						cols='12 12 12 12'
						label='Pesquisar'
						value={this.state.pesquisar}
						onChange={value => this.setState({ ...this.state, pesquisar: value })} />
						
					<div style={{ width: 310, marginTop: 8, marginLeft: 8 }}>
						<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
							onClick={() => {
								this.props.setModoTela('cadastro', {});
								this.props.initForm({});
							}}>
							<i class='fas fa-plus'></i> Adicionar
						</a>
					</div>
				</Row>
				<ContentCardBody style={{ paddingTop: 0 }}>
					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: '100%'
						}}>
						<Table responsive border striped alturaFixa
							maxHeight={'100%'}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { nome: this.getNovaOrdenacao(this.state.ordenacao.nome) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Nome {this.getIconeOrdenacao(this.state.ordenacao.nome)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { padrao: this.getNovaOrdenacao(this.state.ordenacao.padrao) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Padrão {this.getIconeOrdenacao(this.state.ordenacao.padrao)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { data_inicio: this.getNovaOrdenacao(this.state.ordenacao.data_inicio) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Início {this.getIconeOrdenacao(this.state.ordenacao.data_inicio)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { data_fim: this.getNovaOrdenacao(this.state.ordenacao.data_fim) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Término {this.getIconeOrdenacao(this.state.ordenacao.data_fim)}</Th>
									<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter></Th>
								</Tr>
							</THead>
							<TBody>
								{lista.map((item, i) => (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td color={'#000'} alignCenter small>{item.nome}</Td>
										<Td color={'#000'} alignCenter small>{item.padrao ? 'Sim': 'Não'}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_inicio)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_fim)}</Td>
										<Td minWidth={50} width={150} alignCenter>
											{item.id_usuario_inclusao == this.props.sessao.id && //Apenas o usuário que incluiu pode editar
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('cadastro', {
														...item
													});
													this.props.initForm({
														...item,
														nome_aux: this.props.nome
													});
												}} />}

											{item.id_usuario_inclusao == this.props.sessao.id && //Apenas o usuário que incluiu pode editar
											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('exclusao', {
														...item
													});
													this.props.initForm({
														...item,
														nome_aux: this.props.nome
													});
												}} />}
										</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.configImagemLogin.aguardando,
	modoTela: state.configImagemLogin.modoTela,
	lista: state.configImagemLogin.lista,
	filtro: state.configImagemLogin.filtro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, excluir, getLista, getListaComentarioTipo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ConfigImagemLogin);
